import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import { ReduxState } from '../../types/app';

type Props = {
  to: string;
  className?: string;
  onClick?: () => void;
};

export const HeaderEmail = ({ to, className, onClick }: Props) => {
  const client = useSelector((state: ReduxState) => state.Client.data);
  const brokerLine =
    client?.OtherBroker && client.SourceTradingAccountId != null
      ? `${client.SourceBrokerName ?? ''} ID: ${client.SourceTradingAccountId}`.trim()
      : '';

  return (
    <Link
      className={[
        'header__email',
        brokerLine ? 'header__email_broker' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      to={to}
      onClick={onClick}
    >
      <span className="header__email-value">{client?.Email}</span>
      {brokerLine ? (
        <span className="header__email-broker">{brokerLine}</span>
      ) : null}
    </Link>
  );
};
